import { makeStyles } from "@material-ui/core";
/**
 * This function contains the styles used in the PlayScenarioPage
 */
export default function useStyles() {
  return makeStyles({
    canvasContainer: {
      height: "100vh",
      width: "100vw",
    },
  })();
}
